var myTitle = document.title;
    function titleBlink() {
        _record++;
        if (_record == 3) { //当变量_record累加到3是，将其赋值为1。相当于无限循环。
            _record = 1;
        }
        if (_record == 1) {
            document.title = myTitle;
        }
        if (_record == 2) {
            document.title = window.blurTitle||myTitle;
        }

    }
    // 各种浏览器兼容
    var hidden, state, visibilityChange, timerTitle;
    if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
        visibilityChange = "visibilitychange";
        state = "visibilityState";
    } else if (typeof document.mozHidden !== "undefined") {
        hidden = "mozHidden";
        visibilityChange = "mozvisibilitychange";
        state = "mozVisibilityState";
    } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
        state = "msVisibilityState";
    } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
        state = "webkitVisibilityState";
    }
    document.addEventListener(visibilityChange, function() {
        if (document[state] == "visible") {
            clearInterval(timerTitle);
            document.title = myTitle;

        } else {
            _record = 0;
            timerTitle = setInterval("titleBlink()", 500);
        }

    }, false);